import React from 'react';
import { motion } from 'framer-motion';
import { ArrowButton } from '../components/ui';
import { IsoFallback } from '../three/Hero3D';

export default function NotFound() {
  return (
    <section className="notfound">
      <div className="aurora" />
      <div style={{ position: 'absolute', inset: 0, opacity: 0.5 }}><IsoFallback /></div>
      <div style={{ position: 'relative' }}>
        <motion.div className="big gradient-text" initial={{ opacity: 0, scale: 0.6, rotateX: 60 }} animate={{ opacity: 1, scale: 1, rotateX: 0 }} transition={{ delay: 0.5, type: 'spring', stiffness: 120, damping: 12 }}>404</motion.div>
        <h1 className="h2" style={{ margin: '12px 0' }}>This block isn't built yet.</h1>
        <p className="lead" style={{ margin: '0 auto 30px' }}>The page you're looking for doesn't exist or has moved.</p>
        <ArrowButton to="/">Back to home</ArrowButton>
      </div>
    </section>
  );
}
